import React from "react";
import { Navigate, RouteObject } from "react-router";
import { publicPaths } from "./../paths";
import Demo from "common/components/layout/Layout";

const QuickSightDashboard = React.lazy(() => import("features/quickSightDashboard"));
const PricingDashboardMobile = React.lazy(() => import("features/pricing/pages/PricingDashboardMobile"));
const PricingDashboard = React.lazy(() => import("features/pricing"));

const PreviewPricingMobile = React.lazy(() => import("features/purchasePreview/pages/PreviewPricingMobile"));
const PreviewPricingDashboard = React.lazy(() => import("features/purchasePreview/pages/PreviewPricingDashboard"));
const publicRoutes: RouteObject[] = [
  {
    path: "/",
    children: [
      {
        path: publicPaths.home,
        element: <QuickSightDashboard />,
      },
      {
        path: publicPaths.demoLayout,
        element: <Demo />,
      },
      {
        path: publicPaths.quicksightDashboardEmbeded,
        element: <QuickSightDashboard />,
      },
      {
        path: publicPaths.pricing,
        element: <PricingDashboard />,
      },
      {
        path: publicPaths.previewPricing,
        element: <PreviewPricingDashboard />,
      },
    ],
  },
  // TODO: Redirect user to 404 page not found page once its ready
  {
    path: "*",
    element: <Navigate to="/" />,
  },
];

const mobilePublicRoutes: RouteObject[] = [
  {
    path: "/",
    children: [
      {
        path: publicPaths.pricing,
        element: <PricingDashboardMobile />,
      },
      {
        path: publicPaths.previewPricing,
        element: <PreviewPricingMobile />,
      },
    ],
  },
  // TODO: Redirect user to 404 page not found page once its ready
  {
    path: "*",
    element: <Navigate to="/" />,
  },
];
export { publicRoutes, mobilePublicRoutes };
